import { LinearGradient } from 'expo-linear-gradient'
import { DS } from '../../design-system'
// import MyFirstGameBg from '../../../assets/MyFirstGame/first-game-bg.svg'
import React, { useCallback, useMemo } from 'react'
import { useStore } from '../../models'
import { observer } from 'mobx-react-lite'
import { Image, Platform, useWindowDimensions, View } from 'react-native'
import MyFirstGameSteps from '../../models/game/first-game/MyFirstGameSteps'
import { FirstGameBackgroundSVG } from './FirstGameBackgroundSvg'
import { webBgStyles } from './MyFirstGameBackground.web.styles'

const svgBackgroundSize = {
  height: 480,
  width: 402
}

const isWeb = Platform.OS === 'web'

const MyFirstGameBackground = observer(() => {
  const {
    game: { firstGameStage }
  } = useStore()

  const { width, height } = useWindowDimensions()
  const isSmallerDevice = useMemo(() => width <= 375, [width])
  const cols = useMemo(() => Math.ceil(height / svgBackgroundSize.height), [height])
  const rows = useMemo(() => Math.ceil(width / svgBackgroundSize.width), [width])

  const renderRows = useCallback(
    (index: number) => {
      return (
        <View
          key={index}
          style={{
            flexDirection: 'row'
          }}
        >
          {Array.from({ length: rows + 1 }).map((_, index) => (
            <FirstGameBackgroundSVG
              key={`bg-${index}`}
              height={svgBackgroundSize.height}
              width={svgBackgroundSize.width}
              style={{
                marginTop: isWeb && index % 2 === 1 ? -60 : 0
              }}
            />
          ))}
        </View>
      )
    },
    [rows]
  )

  if (firstGameStage >= MyFirstGameSteps.length - 1) {
    return (
      <LinearGradient
        colors={['#7B043D', '#4A0225']}
        style={
          isWeb ? [webBgStyles.linearGradient] : [{ height: height * 1.2, width: width * 1.2, position: 'absolute' }]
        }
        locations={[0, 1]}
      >
        <DS.Frame style={{ flex: 1 }}>
          <Image
            source={require('../../assets/MyFirstGameBackground.png')}
            resizeMode="cover"
            style={isWeb ? webBgStyles.lastScreenImage : { width, height: isSmallerDevice ? height : height * 1.1 }}
          />
        </DS.Frame>
      </LinearGradient>
    )
  }

  return firstGameStage === 0 ? (
    <View
      id="firstGameStage-container"
      style={{
        position: 'absolute',
        width: '100%',
        top: 0,
        bottom: 0,
        overflow: 'hidden',
        zIndex: -1
      }}
    >
      <LinearGradient
        colors={['#7B043D', '#4A0225']}
        style={[
          {
            position: 'absolute',
            width,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        ]}
        locations={[0, 1]}
      />
      <View
        style={{
          position: 'absolute'
        }}
      >
        <View
          style={{
            columnGap: isWeb ? 24 : 0
          }}
        >
          {Array.from({ length: cols + 1 }).map((_, index) => {
            return renderRows(index)
          })}
        </View>
      </View>
    </View>
  ) : Platform.OS === 'web' ? (
    <DS.Frame style={webBgStyles.frame} />
  ) : (
    <DS.Frame style={{ height, width, position: 'absolute', backgroundColor: '#7B043D', zIndex: -2 }} />
  )
})

export default MyFirstGameBackground
